import { TinyEmitter } from "tiny-emitter";

declare global {
  interface Window {
    eventEmitter: TinyEmitter;
  }
}

const eventEmitter: TinyEmitter = new TinyEmitter();
window.eventEmitter = eventEmitter;

export default eventEmitter;
